<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :query-api="queryApi"
                                           :ignoreMaxTableItemLimit="true"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPoResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" :importEnabled="true" :query-api="queryApi"
                                      :ignoreAdd="true" :ignoreDelete="true" :editDisable="true"
                                      detailInlineButtonType="showAttachmentEntity" edit-disable
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      :ignoreMaxTableItemLimit="true"
                                      @linkClick="handleLinkClick"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      :useCustomFieldsDefaultFlag="false"
                                      :custom-form-class="customFormClass"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogConfirmDateVisible = true">确认到货日期
                                    </b-button>
                                    <b-button
                                        :disabled="selectedNotEqualOne"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openExternalInspectionRequestModal">外检申请
                                    </b-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="generateSendList">生成发货清单
                                    </b-button>
                                    <b-button
                                        :disabled="selectedNotEqualOne"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openContractAttachmentModal">上传签字版合同
                                    </b-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled="notSelected"
                                        custom-label="orderCode"
                                        :busy="saveAttachmentLoading"
                                        @click="openAttachmentModal">
                                    </em-button>
                                    <batch-upload-attachment-with-store
                                        title="批量上传质量文件"
                                        attachmentFieldName="qualityFileIds"
                                        :modelName="modelName"
                                        :doQuery="doQuery"
                                        :voName=$_emCustomVuexMixin_vo
                                    />
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="showSdrDialog">发起SDR
                                    </b-button>
                                    <em-button
                                        type="uploadFile"
                                        class="btn btn-outline-primary btn-sm"
                                        :disabled=false
                                        custom-label="导入更新供货日期" show-name
                                        :busy="uploadFile"
                                        @click="openFileUpload">
                                    </em-button>
                                    <b-button
                                        :disabled="notSelected"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="readChangeHistories"
                                    >已读需求日期变更
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="确认到货日期" :visible.sync="dialogConfirmDateVisible">
            <el-form>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="请选择确认类型" label-width="auto">
                            <el-select v-model="confirmType" placeholder="请选择">
                                <el-option v-for="item in confirmOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="请输入合适的确认到货日期:" label-width="auto">
                            <el-date-picker
                                value-format="yyyy-MM-dd HH:mm:ss"
                                v-model="confirmDate"
                                type="datetime"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="reference">
                            <el-input v-model="reference"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogConfirmDateVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmDeliverDate()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="确认类型" :visible.sync="dialogSdrVisible">
            <el-form>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="请选择工程师" label-width="auto" :rules="engineers" required>
                            <el-select filterable multiple v-model="engineers" placeholder="请选择">
                                <el-option v-for="item in engineersOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="技术沟通选择" label-width="auto" required>
                            <el-select v-model="tech" placeholder="请选择">
                                <el-option v-for="item in techOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="comments" required>
                            <el-input v-model="startDesc"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="请上传附件">
                            <multi-attachment class="w-100"
                                              @idsChanged="changeAttachmentIds"
                                              :attachment-ids="attachmentIds">
                            </multi-attachment>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSdrVisible = false">取 消</el-button>
                <el-button type="primary" @click="doSdr()">确 定</el-button>
            </div>
        </el-dialog>
        /*
        <el-dialog title="数量" :visible.sync="sendListFlag">
            <el-form>
                <el-form-item label="请输入清单数量:" label-width="auto">
                    <el-input-number v-model="listQuantity" :min="1" label="数量"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sendListFlag = false">取 消</el-button>
                <el-button type="primary" @click="generateSendList()">确 定</el-button>
            </div>
        </el-dialog>
        */

        <ReBModal header="上传附件"
                  @ok="submitAttachmentChange"
                  ref="uploadAttachment">
            <multi-attachment class="w-100"
                              :query-api="attachmentQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>

        <ReBModal header="上传合同附件"
                  @ok="submitContractAttachmentChange"
                  ref="uploadContractAttachment">
            <multi-attachment class="w-100"
                              :query-api="attachmentQueryApi"
                              @loading="attachmentLoading"
                              @idsChanged="changeAttachmentIds"
                              :attachment-ids="attachmentIds"></multi-attachment>
        </ReBModal>

        <ReBModal header="外检申请"
                  @ok="doExternalInspection"
                  ref="uploadExternalInspectionRequestAttachment">
            <el-form :model="externalInspectionForm" :rules="externalInspectionRules" ref="externalInspectionForm"
                     label-width="100px">
                <el-form-item label="检查点" prop="inspectionPoint">
                    <el-input type="textarea" :rows="3" placeholder="请输入检查点"
                              style="width: 98%;"
                              v-model="externalInspectionForm.inspectionPoint"
                              autocomplete="off"></el-input>
                    <br>
                </el-form-item>
                <el-form-item label="外检申请">
                    <multi-attachment class="w-100"
                                      :query-api="attachmentQueryApi"
                                      @loading="attachmentLoading"
                                      @idsChanged="changeAttachmentIds"
                                      :attachment-ids="attachmentIds"></multi-attachment>
                </el-form-item>
            </el-form>
        </ReBModal>
        <el-dialog title="数量" :visible.sync="uploadQualityFilesFlag">
            <el-upload
                class="upload-demo"
                :headers="headers"
                :action="entityBaseUrl+'uploadQualityFiles'"
                multiple>
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updatePoStatus()">请确认</el-button>
            </div>
        </el-dialog>

        <b-modal id="modal-import" ref="importModal" title="导入数据" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
                <b-form-group
                    id="templateFile"
                    label="选择数据源文件:"
                    label-for="input-dataFile"
                    invalid-feedback="必须选择数据源">
                    <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2"
                                 :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件"
                                 :file-name-formatter="formatNames"
                                 accept=".xls,.xlsx" required></b-form-file>
                </b-form-group>
                <b-row align-h="end" style="margin-top: 30px">
                    <b-button type="submit" variant="primary">导入</b-button>
                    <b-button type="reset" variant="light">取消</b-button>
                </b-row>
            </b-form>
        </b-modal>
        <re-b-modal ref="requireDateChangeHistory" header="需求日期操作记录"
                    hide-footer superLarge fit-content>
            <mini-table ref="requireDateChangeHistoryTable"
                        read-only
                        needModelFields
                        :items="requireDateChangeHistories"
                        customVuexName="subview"
                        style="min-height: 350px;"
                        entity-name="sithMesStoolRequireDateChangeHistory">
            </mini-table>
        </re-b-modal>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-07-06 09:52:28

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import BatchUploadAttachmentWithStore from "@/components/common/attachment/BatchUploadAttachmentWithStore";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import MiniTable from "../../../components/common/mini-table/MiniTable.vue";
import stoolPoMixin from "../../../mixin/em/common/stuffs/stool/stoolPoMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";

export default {
    name: "sithMesStoolPoListView",
    components: {MiniButton, MultiAttachment, ReBModal, BatchUploadAttachmentWithStore, MiniTable},
    mixins: [emCommonListMixin, emCommonGotoMixin, emApiMixin, commonViewsUtil, emCustomVuexMixin, stoolPoMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            file: null,
            uploadFile: false,
            confirmDate: '',
            reference: '',
            startDesc: '',
            laConfirmDate: '',
            dialogConfirmDateVisible: false,
            dialogSdrVisible: false,
            dialogAsnVisible: false,
            listQuantity: '',
            sendListFlag: false,
            attachmentIds: '',
            saveAttachmentLoading: false,
            uploadQualityFilesFlag: false,
            queryApi: 'findAllByVendor',
            externalInspectionForm: {
                inspectionPoint: '',
            },
            externalInspectionRules: {
                inspectionPoint: [
                    {required: true, message: '请输入检查点', trigger: 'blur'}
                ]
            },
            confirmType: '',
            confirmOptions: [
                {
                    label: 'AB',
                    value: 'AB'
                }, {
                    label: 'LA',
                    value: 'LA'
                }
            ],
            engineers: [],
            tech: '',
            engineersOptions: [],
            techOptions: [
                {
                    label: 'SDR',
                    value: '0'
                }, {
                    label: '技术澄清',
                    value: '1'
                }
            ],
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        $_emCustomVuexMixin_vo: {
            type: String,
            default: 'vendorVo'
        },
        $_emCustomVuexMixin_filter: {
            type: String,
            default: 'vendorFilter'
        },
    },
    computed: {
        modelName() {
            return 'sithMesStoolPo';
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi('sithMesStoolPo')}/`
        },
        headers() {
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt;
            }
            return headers;
        },
        attachmentQueryApi() {
            return `${process.env.VUE_APP_SITHMES_PRD_URL}/${this.modelName}/getAttachmentList`;
        },
        $_rowMaterialKey() {
            return 'materialNumber';
        }
    },
    methods: {
        openFileUpload() {
            this.file = null;
            this.$refs.importModal.show();
        },
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`
        },
        handleSubmit(event) {
            event.preventDefault()
            let formData = new FormData();
            formData.append('file', this.file);

            this.$emit('begin');
            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/importFileUpdateDeliveryDate"
            this.$_emApiMixin_post(url, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    //让页面刷新数据
                    this.$store.commit(`${this.entity}/setNeedToRefresh`, true, {
                        root: true
                    })
                }).finally(() => this.$emit('end'));

            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        handleReset() {
            this.selectedMachineType = null;
            this.file = null;
            this.$nextTick(() => {
                this.$bvModal.hide('modal-import')
            })
        },
        confirmDeliverDate() {

            this.dialogConfirmDateVisible = false;
            let arr = this.selectedItems.map(row => {
                row.reference = this.reference;
                if (this.confirmType === 'AB') {
                    row.deliveryDateAb = this.confirmDate;
                } else if (this.confirmType === 'LA') {
                    row.deliveryDateLa = this.confirmDate;
                }
                return row;
            });
            let confirmDeliverUrl = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/confirmDeliverDate";
            this.$_emApiMixin_post(confirmDeliverUrl, arr).then(() => {
                commonViewsUtil.showSuccess(this, "操作成功！");
                this.$refs['emListFilter'].doQuery();
            });
        },
        handleChange(file) {
            if (file.size > 50 * 1024 * 1024) {
                this.$message.warning({
                    duration: 10000,
                    message: "文件超过50M，请压缩后再上传"
                });
            }
        },
        doExternalInspection() {
            let self = this;
            self.$refs["externalInspectionForm"].validate(valid => {
                if (valid) {
                    let id = this.$_emCustomVuexMixin_checkItems[0];
                    let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/doExternalInspection";
                    this.$_emApiMixin_post(url, {
                        id: id,
                        inspectionPoint: this.externalInspectionForm.inspectionPoint,
                        extInspectionRequestAttachmentIds: this.attachmentIds
                    }).then(() => {
                        this.$message.success("保存成功");
                        this.externalInspectionForm.inspectionPoint = '';
                        this.$refs.emListFilter.doQuery();
                    });
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return false;
                }
            })
        },
        generateSendList() {
            for (let item of this.selectedItems) {
                if (!item.deliveryDateLa) {
                    this.$message.warning("请先维护LA到货日期！")
                    return;
                }
            }

            let url = this.$store.state.sithMesStoolDeliverList.baseModuleUrl + "/sithMesStoolDeliverList/generateSendList";
            this.$_emApiMixin_post(url, this.selectedItems).then(() => {
                commonViewsUtil.showSuccess(this, "生成成功！");
                this.$router.push({name: 'sithMesStoolDeliverListList'});
            });
        },
        getDetailInlineButtonType(row) {

            if (row.poReport) {
                return 'showAttachmentEntity';
            }

            return 'showEntity';

        },

        openAttachmentModal() {
            this.attachmentIds = this.selectedItems[0].attachments;
            this.$refs.uploadAttachment.showModal();
        },
        openContractAttachmentModal() {
            this.attachmentIds = this.selectedItems[0].attachments;
            this.$refs.uploadContractAttachment.showModal();
        },
        openExternalInspectionRequestModal() {
            let checkItem = this.selectedItems[0];
            this.attachmentIds = checkItem.extInspectionRequestAttachmentIds;
            this.externalInspectionForm.inspectionPoint = checkItem.inspectionPoint;
            this.$refs.uploadExternalInspectionRequestAttachment.showModal();
        },

        submitAttachmentChange() {
            this.saveAttachmentLoading = true;
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                ids: this.$_emCustomVuexMixin_checkItems,
                poReport: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveAttachmentLoading = false);
        },
        submitContractAttachmentChange() {
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/" + this.modelName + "/upload/attachment";
            this.$_emApiMixin_put(api, {
                ids: this.$_emCustomVuexMixin_checkItems,
                poVendorContractReport: this.attachmentIds === undefined ? "" : this.attachmentIds
            }).then(() => {
                this.$message.success("保存成功");
                this.$refs.emListFilter.doQuery();
            });
        },
        attachmentLoading(val) {
            this.$refs.uploadAttachment.changeLoading(val);
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        showSdrDialog() {
            this.dialogSdrVisible = true;
            this.engineersOptions = [];
            var url = this.$store.state.emAclUser.baseModuleUrl + "/emAclRoleUser/getUserByRoleCode?code=sdr_approver";
            this.$store.dispatch("api/get", {url})
                .then(data => {
                    data.forEach((item) => {
                        this.engineersOptions.push({
                            value: item['name'] + '-' + item['loginName'],
                            label: item['name'] + '-' + item['loginName']
                        });
                    });
                });
        },
        doSdr() {
            let api = process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesStoolPoSdr/generateSdr";
            if (this.engineers.length === 0) {
                this.$message.warning("请选择工程师后再提交sdr！");
                return;
            }
            if (this.tech.length === 0) {
                this.$message.warning("请选择技术沟通类型后再提交sdr！");
                return;
            }
            if (this.startDesc.length === 0) {
                this.$message.warning("请输入comments后再提交sdr！");
                return;
            }
            this.$_emApiMixin_post(api, {
                ids: this.$_emCustomVuexMixin_checkItems,
                attachmentIds:this.attachmentIds,
                engineers: this.engineers,
                comments: this.startDesc,
                type: this.tech
            }).then(() => {
                this.dialogSdrVisible = false;
                this.$message.success("保存成功");
                this.$router.push({name: 'sithMesStoolPoSdrList'});
            });
        },
        updatePoStatus() {
            const ids = this.$_emCustomVuexMixin_checkItems.join(",");
            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/updatePoStatus?ids=" + ids;
            this.$_emApiMixin_post(url, {})
                .then(() => {
                    this.uploadQualityFilesFlag = false;
                    commonViewsUtil.showSuccess(this, "操作成功！");
                    this.$refs["emListFilter"].doQuery();
                })

        },
        doQuery() {
            this.$refs["emListFilter"].doQuery();
        },
        customFormClass: (col, row) => {
            if (col.key === 'prdScheduleDate' && row.hasUnReadRequireDateChangeHistory === true) {
                return 'bg-danger text-white';
            }
            return '';
        },
    },
    mounted() {
        if (this.$route.query.hasOwnProperty('id')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.id);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
